import React, { Fragment } from "react"
import { useMainEnterpriseId } from "../../hooks/enterprise"
import { useShopId } from "../../hooks/shop"
import { useShopSalePointId } from "../../hooks/shopSalePoint"
import {
  useShopPaymentPointFindAllForSalePointID,
  useShopPaymentPointId,
} from "../../hooks/shopPaymentPoint"
import queryString from "query-string"
import { useItemSearchText } from "../../hooks/item"
import classNames from "classnames"
import { useRouter } from "next/router"
import { useAtom as GetAtom } from "jotai"
import {
  checkoutIsNeedCalculateSumBackAtom,
  checkoutRaisePercentAtom,
  checkoutSumGiveAtom,
  checkoutSumTotalAtom,
} from "../../store/checkout"

export default function ShopPaymentPointList() {
  const router = useRouter()

  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()
  const shopPaymentPointId = useShopPaymentPointId()
  const searchText = useItemSearchText()

  const [checkoutSumTotal] = GetAtom(checkoutSumTotalAtom)
  const [, setCheckoutSumGive] = GetAtom(checkoutSumGiveAtom)
  const [, setIsNeedCalculateSumBack] = GetAtom(
    checkoutIsNeedCalculateSumBackAtom
  )
  const [, setRaisePercent] = GetAtom(checkoutRaisePercentAtom)

  const { shopPaymentPoints, isError, isLoading } =
    useShopPaymentPointFindAllForSalePointID(enterpriseId, shopSalePointId)

  if (isLoading) {
    return <p>Загрузка...</p>
  }

  if (isError) {
    return <p>Ошибка: {isError}</p>
  }

  const onSelectPaymentMethod = async (shopPaymentPoint) => {
    let isNeedCalculateSumBack = shopPaymentPoint.typeOfPayment !== "CASH"

    await setIsNeedCalculateSumBack(isNeedCalculateSumBack)
    await setRaisePercent(shopPaymentPoint.percentRaiseOfSale || "0")

    if (isNeedCalculateSumBack) {
      await setCheckoutSumGive(checkoutSumTotal)
    } else {
      await setCheckoutSumGive("0")
    }

    await router.push(
      `/e/${enterpriseId}/${shopId}/${shopSalePointId}/sales?${queryString.stringify(
        {
          searchText: searchText || null,
          shopPaymentPointId: shopPaymentPoint.id,
        },
        { skipNull: true }
      )}`
    )
  }

  return (
    <Fragment>
      <div className="grid grid-cols-1 gap-4">
        {shopPaymentPoints &&
          shopPaymentPoints.map((shopPaymentPoint) => (
            <div
              key={shopPaymentPoint.id}
              className={classNames(
                "relative flex items-center space-x-3 rounded-lg",
                "border border-gray-300",
                "px-6 py-5 shadow-sm",
                "focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2",
                {
                  "bg-white text-gray-900 hover:border-gray-400 hover:bg-gray-100":
                    shopPaymentPoint.id !== shopPaymentPointId,
                  "bg-indigo-500 text-white hover:bg-indigo-600":
                    shopPaymentPoint.id === shopPaymentPointId,
                }
              )}
            >
              <div className="min-w-0 flex-1">
                <button
                  className="focus:outline-none"
                  onClick={() => onSelectPaymentMethod(shopPaymentPoint)}
                >
                  <span className="absolute inset-0" aria-hidden="true" />
                  <p className="text-sm font-medium">
                    {shopPaymentPoint.title}
                  </p>
                </button>
              </div>
            </div>
          ))}
      </div>
    </Fragment>
  )
}
